import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/fonts/fontawesome5-overrides.min.css'
import '@/assets/bootstrap/css/bootstrap.min.css'
import '@/assets/fonts/fontawesome-all.min.css'
import '@/assets/fonts/font-awesome.min.css'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

import zhCn from 'element-plus/es/locale/lang/zh-cn'

import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import XEUtils from 'xe-utils'

import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'

import { createI18n } from 'vue-i18n'




let cn = require('../public/i18n/cn.json');

let en = require('../public/i18n/en.json');

let messages = {
    '中文': cn,
    'English': en
}
const i18n = createI18n({
    locale: '中文', // set locale
    fallbackLocale: 'English', // set fallback locale
    messages,
})

let app = createApp(App)

app.config.globalProperties.$isMobile = function () {

    return navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )


}

app.config.globalProperties.$tt = function(text) {
    if (!text)
        return text;

    if (!text.includes('☆')) {
        return text;
    }

    if (this.$i18n.locale == "English") {
        return text.split('☆')[1]
    }

    if (this.$i18n.locale == "中文") {
        return text.split('☆')[0]
    }
};

//全局格式化
VXETable.formats.mixin({
    // 格式化日期，默认 yyyy-MM-dd HH:mm:ss
    formatDate({ cellValue }, format) {
        return XEUtils.toDateString(new Date(cellValue), format || "yyyyMMdd");
    },
});



app.use(store).use(router).use(ElementPlus, { locale: zhCn }).use(VXETable).use(VueViewer).use(i18n).mount('#app')